import { SignInPage } from "./SignInPage.js";

export default SignInPage;
